import { render } from "./page.html?vue&type=template&id=b378ad76"
import script from "./IziPage.vue?vue&type=script&lang=ts"
export * from "./IziPage.vue?vue&type=script&lang=ts"

import "./IziPage.vue?vue&type=style&index=0&id=b378ad76&lang=scss"
script.render = render

export default script